import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stepperA11y'
})
export class StepperA11yPipe implements PipeTransform {

  transform(stepName, stepNum, currentStep): any {
    let stepStatus = '';
    if (currentStep > stepNum) {
      stepStatus = '- Completed';
    } else if (currentStep === stepNum) {
      stepStatus = '- Current Step';
    }
    return `Step ${stepNum}: ${stepName} ${stepStatus}`;
  }
}
